import { CONTRIBUTOR_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/contributor';
import { CONTRIBUTION_TYPE_SHALLOW_FRAGMENT, } from '@annunciate/query/dist/queries/contributionType';
export const CONTRIBUTION_SHALLOW_FRAGMENT = `
  ${CONTRIBUTOR_SHALLOW_FRAGMENT}
  ${CONTRIBUTION_TYPE_SHALLOW_FRAGMENT}
  fragment ContributionShallowFragment on Contribution {
    __typename
    id
    contributor {
      ...ContributorShallowFragment
    }
    type {
      ...ContributionTypeShallowFragment
    }
  }
`;
//# sourceMappingURL=contribution.js.map